export const AirtableIcon = ({ className }: { className?: string }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    id="Airtable--Streamline-Svg-Logos"
    height="24"
    width="24"
  >
    <path
      fill="#ffbf00"
      d="M10.743575 2.418595 1.9821575 6.04395c-0.487225 0.20165 -0.4821775 0.8937 0.008105 1.088025L10.78835 10.620925c0.773075 0.306575 1.63395 0.306575 2.4069 0l8.7982 -3.48895c0.49015 -0.194325 0.495325 -0.886375 0.007975 -1.088025L13.24015 2.418595c-0.7994 -0.33075 -1.697325 -0.33075 -2.496575 0Z"
      strokeWidth="0.25"
    />
    <path
      fill="#26b5f8"
      d="M12.77235 12.5261v8.71585c0 0.414575 0.418 0.698425 0.80335 0.545675l9.80375 -3.80535c0.223825 -0.08875 0.3706 -0.304975 0.3706 -0.545675V8.72075c0 -0.414575 -0.418025 -0.698425 -0.803375 -0.545675l-9.80375 3.80535c-0.223675 0.088725 -0.370575 0.304975 -0.370575 0.545675Z"
      strokeWidth="0.25"
    />
    <path
      fill="#ed3049"
      d="m10.48305 12.97585 -2.909525 1.404825 -0.295425 0.142775L1.13625 17.466325C0.7469225 17.65415 0.25 17.370425 0.25 16.937925V8.757375c0 -0.156475 0.08023 -0.29155 0.1878225 -0.3933 0.0448975 -0.045025 0.0957725 -0.0821 0.14864 -0.11145 0.1467775 -0.088075 0.35612 -0.111575 0.5341125 -0.041175l9.3136 3.690175c0.4734 0.187825 0.5106 0.8512 0.048875 1.074225Z"
      strokeWidth="0.25"
    />
    <path
      fill="#000000"
      fillOpacity=".25"
      d="m10.4831 12.97585 -2.90955 1.4048L0.437865 8.364075c0.0448975 -0.045025 0.0957725 -0.0821 0.14864 -0.11145 0.1467775 -0.088075 0.35612 -0.111575 0.534115 -0.041175L10.434225 11.901625c0.4734 0.187825 0.5106 0.8512 0.048875 1.074225Z"
      strokeWidth="0.25"
    />
  </svg>
);
